<template>
  <div class="main-reviews-container">
    <section class="reviews-hero-section">
      <h1 class="store-reviews-head">{{ $static('reviews.title', 'Відгуки про Магазин') }}</h1>
      <h2 class="total-mark-head">{{ $static('reviews.total-mark', 'Загальна оцінка') }}</h2>
      <div class="raiting-container">
        <svg width="45" height="45" viewBox="0 0 45 45" class="raiting-star unfilled" v-for="starPosition in 5"
          :key="starPosition"> fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M19.6615 7.71451C20.926 5.53526 24.0731 5.53527 25.3376 7.71452L29.2101 14.3883C29.5671 15.0035 30.1841 15.4233 30.8873 15.5295L37.3179 16.5007C40.121 16.9241 41.1043 20.4633 38.9212 22.2719L34.2358 26.1538C33.5782 26.6986 33.2689 27.5581 33.4287 28.397L34.7411 35.2895C35.2553 37.9894 32.421 40.0871 29.9891 38.8066L23.5915 35.438C22.908 35.0781 22.0911 35.0781 21.4076 35.438L15.01 38.8066C12.5781 40.0871 9.74382 37.9894 10.2579 35.2894L11.5704 28.397C11.7302 27.5581 11.4209 26.6986 10.7633 26.1538L6.07786 22.2719C3.89482 20.4633 4.87808 16.9241 7.6812 16.5007L14.1118 15.5295C14.815 15.4233 15.432 15.0035 15.7889 14.3883L19.6615 7.71451ZM22.905 9.12607C22.7243 8.81475 22.2748 8.81475 22.0941 9.12607L18.2216 15.7999C17.4363 17.1532 16.0789 18.0768 14.5318 18.3104L8.10123 19.2817C7.70078 19.3422 7.56032 19.8478 7.87218 20.1062L12.5576 23.988C14.0044 25.1867 14.6847 27.0774 14.3333 28.9231L13.0208 35.8156C12.9474 36.2013 13.3523 36.5009 13.6997 36.318L20.0972 32.9494C21.6009 32.1577 23.3982 32.1577 24.9019 32.9494L31.2994 36.318C31.6468 36.5009 32.0517 36.2013 31.9783 35.8156L30.6658 28.9231C30.3144 27.0774 30.9947 25.1867 32.4415 23.988L37.1269 20.1062C37.4388 19.8478 37.2983 19.3422 36.8979 19.2817L30.4673 18.3104C28.9201 18.0768 27.5628 17.1532 26.7775 15.7999L22.905 9.12607Z"
            fill="#ffc828" />
        </svg>
        <div class="raiting-container filled" :style="{ width: `${totalRaiting * 20}%` }">
          <svg width="45" height="45" viewBox="0 0 45 45" fill="none" class="raiting-star filled"
            v-for="starPosition in 5" :key="starPosition" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24.1217 5.61756C23.3991 4.37227 21.6008 4.37227 20.8782 5.61756L15.7894 14.3875C15.4324 15.0027 14.8154 15.4225 14.1122 15.5287L4.57536 16.9691C2.97358 17.211 2.41172 19.2334 3.65917 20.2669L10.7637 26.153C11.4214 26.6978 11.7306 27.5573 11.5708 28.3962L9.71238 38.1558C9.4186 39.6986 11.0382 40.8974 12.4279 40.1656L21.408 35.4372C22.0915 35.0773 22.9084 35.0773 23.5919 35.4372L32.5721 40.1656C33.9617 40.8974 35.5813 39.6986 35.2875 38.1558L33.4291 28.3962C33.2693 27.5573 33.5786 26.6978 34.2362 26.153L41.3407 20.2669C42.5882 19.2334 42.0263 17.211 40.4246 16.9691L30.8877 15.5287C30.1845 15.4225 29.5675 15.0027 29.2106 14.3875L24.1217 5.61756Z"
              fill="#FFC828" />
          </svg>

        </div>
      </div>
      <p class="reviews-count-text">{{ $static('reviews.count1', 'всього') }} <span>{{ totalReviews }}</span> {{
        $static('reviews.count2', 'відгуків') }}</p>
      <button class=" write-review-btn" type="button" @click="openModal">
        {{ $static('reviews.write-new', 'Написати відгук') }}</button>
    </section>

    <section class="reviews-section">
      <h2 class="reviews-header">{{ $static('reviews.title2', 'Відгуки:') }}</h2>

      <ul class="reviews-list" @scroll="handleReviewsListScroll">
        <ReviewItem v-for="(review, reviewNumber) in reviews " :key="reviewNumber" :review="review"
          :reviewNumber="reviewNumber" :moderatedReviewsNumber="moderatedReviewsNumber" />
      </ul>

      <div class="load-more-reviews" v-if="isLoadingReviews">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path
            d="M15.1634 8.73898C14.6358 8.66188 14.1673 9.00919 14.0916 9.50434C13.9016 10.748 13.304 11.8827 12.3632 12.7862C9.96888 15.0857 6.07593 15.0839 3.68255 12.7862C1.28965 10.4876 1.28965 6.74739 3.68255 4.44922C4.58269 3.58518 5.71903 3.02182 6.9908 2.81673C7.53772 2.71705 8.12573 2.69982 8.73583 2.76621C9.57354 2.85882 10.3533 3.12576 11.0648 3.51769L9.83525 3.71933C9.32157 3.80396 8.97562 4.27253 9.06421 4.76633C9.1426 5.20833 9.542 5.52053 9.99391 5.52053C10.0465 5.52053 10.1 5.51654 10.1544 5.50765L13.4506 4.96642C13.6968 4.92569 13.9173 4.79281 14.0621 4.59617C14.2069 4.39997 14.2642 4.15634 14.2217 3.91897L13.6572 0.753672C13.5705 0.260332 13.089 -0.0701023 12.567 0.0127105C12.0533 0.0973373 11.7074 0.566368 11.796 1.06016L11.9445 1.89328C11.0304 1.40075 10.0221 1.08211 8.95069 0.963652C8.1483 0.875941 7.3699 0.90034 6.65742 1.03141C5.01713 1.29536 3.52672 2.03369 2.34703 3.16658C-0.782344 6.17206 -0.782344 11.0625 2.34703 14.0687C3.91167 15.5719 5.96751 16.3231 8.02288 16.3231C10.0787 16.3231 12.1335 15.572 13.6987 14.0687C14.9282 12.888 15.7103 11.4008 15.9602 9.76829C16.0359 9.27223 15.6789 8.81154 15.1634 8.73898Z"
            fill="#353535" />
        </svg>
      </div>
    </section>

  </div>
  <section class="add-review-section-only-mobile">
    <button class="default-btn" type="button" @click="openModal">
      {{ $static('reviews.write-new', 'Написати відгук') }}
    </button>
  </section>

  <!--! Modal for review with logic -->
  <div class="frame-modal-wrapper-bg reviews-modal-wrapper-bg" :class="{ 'is-visible': isCreateReviewModalOpen }"
    @click.self="closeCreateReviewModal">
    <section class="create-review-modal">
      <section class="header">
        <b>{{ $static('reviews.write-new', 'Написати відгук') }}</b>
        <svg class="close-modal-btn" width="20" height="20" viewBox="0 0 20 20" fill="none"
          xmlns="http://www.w3.org/2000/svg" @click.self="closeCreateReviewModal">
          <path d="M15 5L5 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5 5L15 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </section>

      <section class="raiting-section" style="position: relative;">
        <p class="help-text help-text__in-raiting" v-if="modalErrors.notSelectedRaitingError">
          {{ $static('reviews.choose-rating', 'Оберіть оцінку') }}</p>
        <div class="raiting-container in-modal">
          <svg width="45" height="45" viewBox="0 0 45 45" class="raiting-star unfilled in-modal"
            v-for="(starPosition, modalStarIndex) in 5" :key="starPosition" @click="handleStarClick(modalStarIndex)"
            @mouseenter="handleStarHover(modalStarIndex)" @mouseleave="handleStarUnHover(modalStarIndex)"
            :style="{ fill: starActive[modalStarIndex] ? '#FFC828' : 'none' }" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M19.6615 7.71451C20.926 5.53526 24.0731 5.53527 25.3376 7.71452L29.2101 14.3883C29.5671 15.0035 30.1841 15.4233 30.8873 15.5295L37.3179 16.5007C40.121 16.9241 41.1043 20.4633 38.9212 22.2719L34.2358 26.1538C33.5782 26.6986 33.2689 27.5581 33.4287 28.397L34.7411 35.2895C35.2553 37.9894 32.421 40.0871 29.9891 38.8066L23.5915 35.438C22.908 35.0781 22.0911 35.0781 21.4076 35.438L15.01 38.8066C12.5781 40.0871 9.74382 37.9894 10.2579 35.2894L11.5704 28.397C11.7302 27.5581 11.4209 26.6986 10.7633 26.1538L6.07786 22.2719C3.89482 20.4633 4.87808 16.9241 7.6812 16.5007L14.1118 15.5295C14.815 15.4233 15.432 15.0035 15.7889 14.3883L19.6615 7.71451ZM22.905 9.12607C22.7243 8.81475 22.2748 8.81475 22.0941 9.12607L18.2216 15.7999C17.4363 17.1532 16.0789 18.0768 14.5318 18.3104L8.10123 19.2817C7.70078 19.3422 7.56032 19.8478 7.87218 20.1062L12.5576 23.988C14.0044 25.1867 14.6847 27.0774 14.3333 28.9231L13.0208 35.8156C12.9474 36.2013 13.3523 36.5009 13.6997 36.318L20.0972 32.9494C21.6009 32.1577 23.3982 32.1577 24.9019 32.9494L31.2994 36.318C31.6468 36.5009 32.0517 36.2013 31.9783 35.8156L30.6658 28.9231C30.3144 27.0774 30.9947 25.1867 32.4415 23.988L37.1269 20.1062C37.4388 19.8478 37.2983 19.3422 36.8979 19.2817L30.4673 18.3104C28.9201 18.0768 27.5628 17.1532 26.7775 15.7999L22.905 9.12607Z"
              fill="#FFC828" />
            <path
              d="M24.1217 5.61756C23.3991 4.37227 21.6008 4.37227 20.8782 5.61756L15.7894 14.3875C15.4324 15.0027 14.8154 15.4225 14.1122 15.5287L4.57536 16.9691C2.97358 17.211 2.41172 19.2334 3.65917 20.2669L10.7637 26.153C11.4214 26.6978 11.7306 27.5573 11.5708 28.3962L9.71238 38.1558C9.4186 39.6986 11.0382 40.8974 12.4279 40.1656L21.408 35.4372C22.0915 35.0773 22.9084 35.0773 23.5919 35.4372L32.5721 40.1656C33.9617 40.8974 35.5813 39.6986 35.2875 38.1558L33.4291 28.3962C33.2693 27.5573 33.5786 26.6978 34.2362 26.153L41.3407 20.2669C42.5882 19.2334 42.0263 17.211 40.4246 16.9691L30.8877 15.5287C30.1845 15.4225 29.5675 15.0027 29.2106 14.3875L24.1217 5.61756Z" />
          </svg>
        </div>
        <!-- ! старые звезды, можно удалить -->
        <!-- <div class="raiting-container in-modal">
          <svg data-modal-review-raiting width="22" height="22" viewBox="0 0 22 22"
            class="raiting-star unfilled in-modal" v-for="(starPosition, modalStarIndex) in 5" :key="starPosition"
            @click="handleStarClick(modalStarIndex)" @mouseenter="handleStarHover(modalStarIndex)"
            @mouseleave="handleStarUnHover(modalStarIndex)"
            :style="{ fill: starActive[modalStarIndex] ? '#FFEC3F' : 'none' }">
            <path
              d="M17.497 17.9939L17.4335 17.498C17.3881 17.5038 17.3455 17.4967 17.3134 17.4829L17.3091 17.481L11.4778 15.0301C11.1747 14.9026 10.8253 14.9026 10.5221 15.0301L4.69089 17.481L4.68824 17.4822C4.64016 17.5027 4.58244 17.5055 4.53089 17.4905C4.47868 17.4752 4.45787 17.45 4.45269 17.4409C4.45229 17.4402 4.45197 17.4396 4.45171 17.4391L5.36731 11.9419C5.36734 11.9417 5.36738 11.9415 5.36742 11.9413C5.42771 11.5825 5.28507 11.2408 5.02724 11.0132L0.517289 7.0277L0.517294 7.02769L0.515239 7.02589C0.50745 7.01909 0.503388 7.01379 0.501409 7.01072C0.503461 7.00751 0.507863 7.00175 0.516599 6.99435L0.517376 6.99368C0.53532 6.97841 0.567874 6.96116 0.611961 6.95476L0.611962 6.95476L0.613903 6.95447L7.0019 6.00104C7.00205 6.00102 7.0022 6.001 7.00235 6.00098C7.32715 5.95307 7.63633 5.77376 7.81691 5.47975C7.81704 5.47954 7.81717 5.47933 7.8173 5.47912L10.8529 0.561154L10.8529 0.561159L10.8544 0.558618C10.8609 0.548031 10.884 0.52248 10.9375 0.508157C10.9903 0.494025 11.0477 0.498449 11.0943 0.519662L11.0951 0.520027C11.1277 0.534791 11.1414 0.551896 11.1454 0.558467L11.1454 0.558472L11.1471 0.561154L14.1827 5.47912C14.1827 5.47927 14.1828 5.47942 14.1829 5.47957C14.3635 5.7737 14.6728 5.95307 14.9977 6.00098C14.9978 6.001 14.9979 6.00102 14.9981 6.00104L21.3861 6.95448L21.3886 6.95484C21.4491 6.96356 21.4818 6.98981 21.4941 7.00475C21.4961 7.00709 21.4975 7.00906 21.4984 7.01062C21.4963 7.01403 21.4922 7.01938 21.4845 7.02605L21.4827 7.0277L16.9727 11.0132C16.9726 11.0133 16.9726 11.0133 16.9725 11.0134C16.7148 11.241 16.5723 11.5826 16.6325 11.9412C16.6326 11.9414 16.6326 11.9417 16.6326 11.9419L17.5483 17.4397C17.5473 17.4416 17.5454 17.4444 17.5422 17.4482C17.5288 17.4639 17.4944 17.4901 17.4329 17.498L17.497 17.9939Z"
              stroke="#FFEC3F" />
          </svg>
        </div> -->
        <!--        <div class="raiting-container-text">-->
        <!--          <div><span>{{ $static('reviews.rating1', 'погано') }}</span></div>-->
        <!--          <div><span>{{ $static('reviews.rating2', 'так собі') }}</span></div>-->
        <!--          <div><span>{{ $static('reviews.rating3', 'нормально') }}</span></div>-->
        <!--          <div><span>{{ $static('reviews.rating4', 'добре') }}</span></div>-->
        <!--          <div><span>{{ $static('reviews.rating5', 'чудово') }}</span></div>-->
        <!--        </div>-->
        <div class="raiting-container-text">
          <div><span>1</span></div>
          <div><span>2</span></div>
          <div><span>3</span></div>
          <div><span>4</span></div>
          <div><span>5</span></div>
        </div>

      </section>

      <div class="section-line-devider"></div>

      <section class="review-text-section">
        <textarea class="modal-review-textarea" id="" :placeholder="$static('reviews.write-eny', 'напишіть що-небудь')"
          v-model="createdReviewData.comment"></textarea>
        <p class="leave-comment-сall-to-action" v-if="tags.length > 0">
          {{ $static('reviews.compliment', 'Залишіть комплімент:') }}</p>
        <div class="review-block__tag-container review-block__tag-container--in-modal">
          <template v-for="(reviewTag, reviewTagIndex) in tags" :key="reviewTagIndex">
            <input class="review-tag-checkbox" type="checkbox" :value="reviewTag.toLowerCase().trim()"
              :id="'checkbox_' + reviewTag.toLowerCase().trim() + reviewTagIndex"
              @change="handleReviewTagClick(reviewTag, $event)">
            <label :for="'checkbox_' + reviewTag.toLowerCase().trim() + reviewTagIndex"
              class="review-block__tag  review-block__tag--in-modal">
              {{ reviewTag.toLowerCase().trim() }}
            </label>
          </template>
        </div>
      </section>

      <div class="section-line-devider"></div>

      <section class="photo-section">
        <div class="modal-review__photo-container">
          <div class="modal-review__photo-wrapper" v-for="(reviewPhoto, reviewPhotoIndex) in previewPhotosURLArray"
            :key="reviewPhotoIndex">
            <img class="modal-review__photo" :src="reviewPhoto" alt="фото в отзыве">
            <div class="modal-review__photo-overlay"></div>
            <!--            <svg class="modal-review__photo-delete-btn" xmlns="http://www.w3.org/2000/svg" width="20" height="20"-->
            <!--                 viewBox="0 0 20 20" fill="none" @click="removeReviewPhoto(reviewPhotoIndex)">-->
            <!--              <g filter="url(#filter0_d_2187_860)">-->
            <!--                <path-->
            <!--                    d="M7.70768 2.5C7.70768 2.15482 7.9875 1.875 8.33268 1.875H11.666C12.0112 1.875 12.291 2.15482 12.291 2.5V3.125H15.8327C16.1779 3.125 16.4577 3.40482 16.4577 3.75C16.4577 4.09518 16.1779 4.375 15.8327 4.375H4.16602C3.82084 4.375 3.54102 4.09518 3.54102 3.75C3.54102 3.40482 3.82084 3.125 4.16602 3.125H7.70768V2.5Z"-->
            <!--                    fill="#C1272D"/>-->
            <!--                <path fill-rule="evenodd" clip-rule="evenodd"-->
            <!--                      d="M5.19926 6.62065C5.22271 6.40964 5.40107 6.25 5.61338 6.25H14.3853C14.5976 6.25 14.776 6.40964 14.7994 6.62065L14.9662 8.12178C15.2669 10.8276 15.2669 13.5584 14.9662 16.2642L14.9498 16.412C14.8403 17.3975 14.0765 18.1833 13.0946 18.3207C11.0411 18.6082 8.95759 18.6082 6.90413 18.3207C5.92216 18.1833 5.15839 17.3975 5.04889 16.412L5.03247 16.2642C4.73183 13.5584 4.73183 10.8276 5.03247 8.12178L5.19926 6.62065ZM12.108 10.3914C12.352 10.6355 12.352 11.0312 12.108 11.2753L10.8832 12.5L12.108 13.7247C12.352 13.9688 12.352 14.3645 12.108 14.6086C11.8639 14.8527 11.4682 14.8527 11.2241 14.6086L9.99935 13.3839L8.77463 14.6086C8.53055 14.8527 8.13483 14.8527 7.89075 14.6086C7.64667 14.3645 7.64667 13.9688 7.89075 13.7247L9.11547 12.5L7.89074 11.2753C7.64666 11.0312 7.64666 10.6355 7.89074 10.3914C8.13482 10.1473 8.53055 10.1473 8.77462 10.3914L9.99935 11.6161L11.2241 10.3914C11.4682 10.1473 11.8639 10.1473 12.108 10.3914Z"-->
            <!--                      fill="#C1272D"/>-->
            <!--              </g>-->
            <!--              <defs>-->
            <!--                <filter id="filter0_d_2187_860" x="2.54102" y="0.875" width="14.916" height="18.6614"-->
            <!--                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">-->
            <!--                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>-->
            <!--                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"-->
            <!--                                 result="hardAlpha"/>-->
            <!--                  <feOffset/>-->
            <!--                  <feGaussianBlur stdDeviation="0.5"/>-->
            <!--                  <feComposite in2="hardAlpha" operator="out"/>-->
            <!--                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>-->
            <!--                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2187_860"/>-->
            <!--                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2187_860" result="shape"/>-->
            <!--                </filter>-->
            <!--              </defs>-->
            <!--            </svg>-->
            <svg class="modal-review__photo-delete-btn" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg" @click="removeReviewPhoto(reviewPhotoIndex)">
              <g clip-path="url(#clip0_4148_8171)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8 0C3.58881 0 0 3.58878 0 8C0 12.4112 3.58875 16 8 16C12.4113 16 16 12.4112 16 8C16 3.58878 12.4113 0 8 0Z"
                  fill="#FF2C5E" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.5939 10.5158L15.5991 10.4999L15.5995 10.4989C15.6077 10.4741 15.6158 10.4491 15.6237 10.4241C15.6663 10.2908 15.7054 10.156 15.7411 10.0197C15.7544 9.96876 15.767 9.91754 15.7793 9.86623L11.6121 4.96423L11.6301 4.9871L11.6469 5.01082L11.6626 5.03535L11.6771 5.06066L11.6905 5.08673L11.7026 5.11351L11.7134 5.14095L11.7228 5.16907L11.731 5.19776L11.7377 5.22698L11.7431 5.2567L11.7469 5.28691L11.7492 5.31757L11.75 5.34863V5.95288H11.7077L9.49993 3.40723L9.5149 3.42729L9.52793 3.44876L9.5389 3.47151L9.54765 3.49541L9.55409 3.52041L9.55802 3.54623L9.55937 3.57282V4.21582H6.43962L8.09109 5.95288H4.24902L6.79184 8.39954V11.2969L6.79321 11.3239L6.79718 11.3501L6.80368 11.3754L6.81259 11.3997L6.82371 11.4228L6.83693 11.4447L6.85212 11.465L6.86915 11.4837L6.8879 11.5008L8.21912 12.6873H5.65499L5.63543 12.6868L5.61606 12.6854L5.59693 12.683L5.57818 12.6799L5.55965 12.6758L5.5414 12.6709L5.52349 12.665L5.50596 12.6584L5.4888 12.6511L5.47206 12.6429L5.45574 12.634L5.4399 12.6244L5.42452 12.614L5.40968 12.603L5.39534 12.5914L9.33715 15.8873C9.37371 15.881 9.41031 15.8748 9.44671 15.8682C10.0544 15.7566 10.6469 15.5744 11.2123 15.3254L11.2136 15.3249L11.2148 15.3243C11.2331 15.3164 11.2513 15.3085 11.2694 15.3003C11.6216 15.1419 11.9617 14.9582 12.2872 14.7505L12.2883 14.7499L12.2893 14.7492L12.2903 14.7485L12.2914 14.7479L12.2924 14.7472C12.3066 14.7382 12.3208 14.7291 12.3349 14.72C12.5377 14.5888 12.734 14.4487 12.9238 14.2999L12.924 14.3001C13.4093 13.9198 13.8494 13.4852 14.2357 13.0047C14.2603 12.9742 14.2846 12.9435 14.3088 12.9126C14.3147 12.905 14.3206 12.8974 14.3265 12.8897L14.3271 12.8888L14.3274 12.8884L14.3278 12.8879C14.5211 12.6383 14.6995 12.3776 14.8621 12.107L14.8697 12.0944C14.8775 12.0815 14.8851 12.0686 14.8928 12.0557C14.9002 12.0432 14.9076 12.0306 14.9149 12.0179L14.9276 11.9961C14.936 11.9818 14.9442 11.9674 14.9524 11.953L14.9615 11.9371C14.9723 11.918 14.9831 11.8989 14.9937 11.8798L14.9973 11.8733C15.0082 11.8538 15.019 11.8342 15.0296 11.8147L15.0327 11.809C15.1921 11.5161 15.333 11.2134 15.4544 10.9028C15.5041 10.7753 15.5506 10.6463 15.5939 10.5158Z"
                  fill="#FF2C5E" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.67599 11.297V7.59359C8.67602 7.52356 8.70386 7.4564 8.7534 7.4069C8.80294 7.3574 8.87012 7.3296 8.94015 7.32962C9.01018 7.32965 9.07734 7.35749 9.12684 7.40703C9.17634 7.45657 9.20414 7.52375 9.20412 7.59378V11.2971C9.20488 11.3323 9.19862 11.3672 9.18569 11.4C9.17276 11.4327 9.15344 11.4625 9.12884 11.4876C9.10424 11.5127 9.07488 11.5327 9.04246 11.5463C9.01004 11.56 8.97522 11.567 8.94005 11.567C8.90489 11.567 8.87007 11.56 8.83765 11.5463C8.80523 11.5327 8.77587 11.5127 8.75127 11.4876C8.72667 11.4625 8.70735 11.4327 8.69442 11.4C8.68149 11.3672 8.67523 11.3323 8.67599 11.2971V11.297ZM6.79184 11.297V7.59359C6.79186 7.52356 6.81971 7.4564 6.86924 7.4069C6.91878 7.3574 6.98596 7.3296 7.05599 7.32962C7.12603 7.32965 7.19318 7.35749 7.24269 7.40703C7.29219 7.45657 7.31999 7.52375 7.31996 7.59378V11.297C7.3205 11.332 7.31407 11.3668 7.30104 11.3993C7.28801 11.4318 7.26865 11.4614 7.24407 11.4863C7.2195 11.5113 7.19021 11.5311 7.1579 11.5446C7.12559 11.5582 7.09092 11.5651 7.0559 11.5651C7.02088 11.5651 6.9862 11.5582 6.9539 11.5446C6.92159 11.5311 6.8923 11.5113 6.86773 11.4863C6.84315 11.4614 6.82379 11.4318 6.81076 11.3993C6.79773 11.3668 6.7913 11.332 6.79184 11.297ZM11.7503 5.95297H4.24902V5.34862C4.24916 5.18837 4.31288 5.03473 4.42619 4.92141C4.53951 4.80809 4.69315 4.74437 4.8534 4.74422L11.1458 4.74403C11.3061 4.74425 11.4597 4.80803 11.573 4.92138C11.6863 5.03473 11.75 5.18839 11.7502 5.34866V5.95291L11.7503 5.95297ZM10.7145 12.3151L11.1399 6.48109H4.85615L5.2548 12.3135C5.26197 12.4148 5.30722 12.5097 5.38146 12.579C5.4557 12.6484 5.55343 12.6871 5.65502 12.6873H10.3144C10.416 12.6881 10.514 12.6499 10.5884 12.5807C10.6629 12.5115 10.708 12.4165 10.7146 12.3151H10.7145ZM6.43946 3.57263C6.43948 3.50366 6.46687 3.43753 6.51562 3.38875C6.56438 3.33998 6.6305 3.31255 6.69946 3.3125H9.29946C9.36845 3.31266 9.43456 3.34016 9.4833 3.38898C9.53204 3.4378 9.55944 3.50395 9.55949 3.57294V4.21594H6.43962L6.43946 3.57263Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_4148_8171">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <label class="modal-review__photo-upload-btn-immitator" for="review-photo-input">
          <template v-if="isUserLoggedIn || isTelegram">
            <div class="modal-review__photo-upload-content-wrapper">
              <svg class="modal-review__upload-photo-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                viewBox="0 0 10 10" fill="none">
                <g clip-path="url(#clip0_1792_1069)">
                  <path
                    d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z"
                    fill="#14F9A7" />
                  <path d="M5 2.6001V7.6001" stroke="black" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M7.5 5H2.5" stroke="black" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_1792_1069">
                    <rect width="10" height="10" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div class="uplod-input-text-container">
                <span>{{ $static('reviews.upload-images', 'Завантажити зображення') }}</span>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="modal-review__photo-upload-content-wrapper">
              <span>{{ $static('reviews.upload-images-ability',
                'Для можливості завантажити файли або зображення необхідно авторизуватися') }}
              </span>
            </div>
          </template>
          <input type="file" name="review-photo-input" id="review-photo-input" accept="image/*" ref="reviewPhotosInput"
            @change="addReviewPhotos" :disabled="!isUserLoggedIn && !isTelegram">
          <p class="help-text" v-if="modalErrors.reviewPhotoUploadError">
            {{ $static('reviews.help-text1', 'Помилка завантаження фотографії') }}
          </p>
          <p class="help-text" v-if="modalErrors.maxReviewPhotosError">
            {{ $static('reviews.help-text21', 'Перевищено максимальну кількість зображень для всіх ваших відгуків') }}
            ({{
              this.maxFiles || 0 }} {{ $static('reviews.help-text22', 'зображень)') }}
          </p>
          <p class="help-text" v-if="modalErrors.notAuthPhotosError">
            {{ $static('reviews.help-text3', 'Для можливості додати фото відгуку потрібно авторизуватись') }}
          </p>
        </label>
        <section class="review-text-section">
          <p class="leave-comment-сall-to-action small_mb">
            {{ $static('service-request.max-files', '* Доступно до завантаження, шт: ') }}{{
              availableFilesQuantity
            }}</p>
          <p class="leave-comment-сall-to-action small_mb">
            {{ $static('service-request.max-file-size', '* Максимальний розмiр файлу: 2 МБ') }}</p>
          <p v-if="isTelegram" class="leave-comment-сall-to-action small_mb">
            <strong>{{ $static('service-request.one-file-upload', '* Завантажуйте по одному файлу!') }} </strong>
          </p>
        </section>
      </section>

      <div class="section-line-devider"></div>

      <section class="send-btn-section">
        <button class="default-btn write-review-btn--in-modal" type="button" @click="postReview($event)"
          :style="{ opacity: isReviewSending ? '0.5' : '1' }">{{ $static('reviews.sending', 'Відправити') }}
        </button>
      </section>
    </section>
  </div>

  <!--! Modal after review sending -->
  <div class="frame-modal-wrapper-bg after-review-modal-wrapper-bg" v-if="isReviewSent && isReviewSentSuccessfully"
    :class="{ 'is-visible': isReviewSent }" @click.self="closeModalAfterReviewSend">
    <section class="review-after-send-modal">
      <svg class="close-modal-btn close-modal-btn__review-after-send-modal" width="20" height="20" viewBox="0 0 20 20"
        fill="none" xmlns="http://www.w3.org/2000/svg" @click.self="closeModalAfterReviewSend">
        <path d="M15 5L5 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5 5L15 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <div class="review-after-send-modal__content-wrapper" v-if="isReviewSentSuccessfully">
        <div class="after-send-icon">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4148_4833)">
              <path
                d="M10.6804 22.4145C9.74325 22.4145 8.86209 22.0495 8.19939 21.3869C7.93223 21.1197 7.93223 20.6866 8.19939 20.4193C8.46655 20.1523 8.89972 20.1523 9.16693 20.4193C9.5712 20.8237 10.1088 21.0463 10.6805 21.0463C11.2522 21.0463 11.7897 20.8237 12.194 20.4193L24.0068 8.60663C24.4111 8.20236 24.6337 7.66479 24.6337 7.09309C24.6337 6.5214 24.4111 5.98388 24.0068 5.57961C23.1721 4.74491 21.8142 4.74496 20.9797 5.57956L14.3984 12.1609C14.1312 12.4279 13.6982 12.4279 13.4309 12.1609C13.1637 11.8937 13.1637 11.4605 13.4309 11.1933L20.0122 4.61192C21.3803 3.24402 23.6061 3.24387 24.9743 4.61192C26.3424 5.98002 26.3424 8.20602 24.9743 9.57407L13.1615 21.3869C12.4988 22.0496 11.6177 22.4145 10.6804 22.4145Z"
                fill="#14F9A7" />
              <path
                d="M14.6241 18.855L12.6268 20.8523C11.5237 21.9553 9.73528 21.9553 8.63221 20.8523L1.50992 13.7301C0.406849 12.627 0.406849 10.8386 1.50992 9.73551C2.61299 8.63244 4.40141 8.63244 5.50448 9.73551L14.6241 18.855Z"
                fill="#14F9A7" />
              <path
                d="M10.2428 14.1967L12.4438 16.4145C13.6594 17.6394 14.1484 18.952 15.364 17.7271L24.6947 8.50576C25.9103 7.28086 25.9103 5.29493 24.6947 4.07004C23.4791 2.84514 21.5083 2.84514 20.2927 4.07004L10.2428 14.1967Z"
                fill="#14F9A7" />
              <path
                d="M10.6293 22.3633C9.69203 22.3633 8.81097 21.9983 8.14827 21.3357L1.02604 14.2134C-0.342012 12.8453 -0.342012 10.6193 1.02604 9.25124C1.68884 8.58855 2.56989 8.22363 3.50706 8.22363C4.44433 8.22363 5.32539 8.5886 5.98809 9.25124L15.1077 18.3708C15.3748 18.638 15.3748 19.0711 15.1077 19.3383L13.1104 21.3356C12.4476 21.9983 11.5665 22.3633 10.6293 22.3633ZM3.50706 9.59189C2.93536 9.59189 2.39784 9.81451 1.99352 10.2188C1.15898 11.0534 1.15898 12.4114 1.99352 13.246L9.11576 20.3681C9.52003 20.7724 10.0575 20.995 10.6293 20.995C11.201 20.995 11.7385 20.7724 12.1428 20.3681L13.6564 18.8546L5.02055 10.2188C4.61628 9.81451 4.07881 9.59189 3.50706 9.59189Z"
                fill="#14F9A7" />
            </g>
            <defs>
              <clipPath id="clip0_4148_4833">
                <rect width="26" height="26" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <b>{{ $static('reviews.as-thanks', 'Дякую!') }}</b>
        <p>{{ $static('reviews.as-msg', 'Ваш відгук надіслано на модерацію і незабаром буде опубліковано') }}</p>
      </div>
    </section>
  </div>

  <div class="frame-modal-wrapper-bg after-review-modal-wrapper-bg" v-if="isReviewSent && !isReviewSentSuccessfully"
    :class="{ 'is-visible': isReviewSent }" @click.self="closeModalAfterReviewSend">
    <section class="review-after-send-modal">
      <svg class="close-modal-btn close-modal-btn__review-after-send-modal" width="20" height="20" viewBox="0 0 20 20"
        fill="none" xmlns="http://www.w3.org/2000/svg" @click.self="closeModalAfterReviewSend">
        <path d="M15 5L5 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5 5L15 15" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <div class="review-after-send-modal__content-wrapper">
        <b class="send-modal-error">{{ $static('reviews.as-thanks-error', 'Помилка!') }}</b>
        <p>{{ $static('reviews.as-not-send', 'Відгук не був надісланий') }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import { fixBodyPadding } from '@/utils/fixBodyPadding.js';
import ReviewItem from '@/components/ReviewItem.vue'

export default {
  name: 'Reviews',
  components: { ReviewItem },
  data() {
    return {
      reviews: [],
      totalReviews: 0,
      moderatedReviewsNumber: 0,
      isCreateReviewModalOpen: false,
      isReviewSent: false,
      isReviewSentSuccessfully: false,
      isReviewSending: false,
      starActive: [false, false, false, false, false],
      createdReviewData: {
        name: '',
        reviewRaiting: undefined,
        comment: '',
        tags: [],
        photo: [],
        reviewTime: undefined,
        reviewAuthorAvatar: undefined

      },
      previewPhotosURLArray: [],
      reviewPhotoFiles: [],
      isLoadingReviews: false,
      loadMore: undefined,
      modalErrors: {
        maxReviewPhotosError: false,
        reviewPhotoUploadError: false,
        notSelectedRaitingError: false
      }
    }
  },
  computed: {
    userInfo() {
      let userInfo = JSON.parse(localStorage.getItem('user_info'));

      if (userInfo) { return userInfo }
      if (this.$store.getters.getUserInfo) { return this.$store.getters.getUserInfo } else {
        return undefined
      }
    },
    account() {
      return this.$store.getters.getAccount
    },
    isTelegram() {
      if (window.Telegram && window.Telegram?.WebApp && window.Telegram.WebApp.initData && window?.Telegram?.WebApp?.initData.length > 0) { return true }
      else { return false }
    },
    isUserLoggedIn() {
      if (this.isTelegram) {
        return (window?.Telegram?.WebApp?.initData.length > 0) ? true : false;
      } else {
        return this.$store.getters.getUserInfo ? true : false;
      }
    },
    fileCount() {
      return this.$store.getters.getFileCount;
    },
    maxFiles() {
      return Number(this.fileCount.max_file);
    },
    totalUserFiles() {
      return Number(this.fileCount.review);
    },
    availableFilesQuantity() {
      return (this.maxFiles - this.totalUserFiles) >= 0 ? this.maxFiles - this.totalUserFiles : 0;
    },
    totalRaiting() {
      return this.$store.getters.getSettings.rating ? this.$store.getters.getSettings.rating : 4.8
    },
    tags() {
      const tagsData = { ...this.$store.getters.getSettings.tags }
      console.log(tagsData)
      if (typeof tagsData === 'object' && tagsData?.reviewTags && typeof tagsData?.reviewTags === 'string') {
        console.log(this.$dynamic)
        console.log(tagsData.translate["en"].reviewTags)
        return this.$dynamic(tagsData, tagsData.reviewTags, 'reviewTags').split(',');
      }
      return []
    }
  },

  methods: {
    openModal() {
      this.isCreateReviewModalOpen = true;
      fixBodyPadding();
      document.body.classList.add('no-scroll');
    },

    openModalAfterReviewSent(status) {
      this.isReviewSent = true;
      fixBodyPadding();
      document.body.classList.add('no-scroll');

      if (status == 200) { this.isReviewSentSuccessfully = true; }
    },

    closeCreateReviewModal(event) {

      if (!event.target.classList.contains('write-review-btn--in-modal')) {
        this.createdReviewData.photo.forEach((_, revPhotoIdx) => { this.removeReviewPhoto(revPhotoIdx); });
      }

      this.isCreateReviewModalOpen = false;
      this.isReviewSending = false;
      this.starActive = [false, false, false, false, false];
      this.createdReviewData = {
        name: '',
        reviewRaiting: undefined,
        comment: '',
        tags: [],
        photo: [],
        reviewTime: undefined
      };
      this.previewPhotosURLArray = [];
      this.reviewPhotoFiles = [];

      this.modalErrors = {
        notAuthPhotosError: false,
        maxReviewPhotosError: false,
        reviewPhotoUploadError: false,
        notSelectedRaitingError: false
      };

      this.resetReviewTagsCheckboxes();

      fixBodyPadding();
      document.body.classList.remove('no-scroll');
    },

    closeModalAfterReviewSend() {
      this.isReviewSent = false;
      this.isReviewSentSuccessfully = false;

      fixBodyPadding();
      document.body.classList.remove('no-scroll');
    },
    //helpers for work with reviews data________________________________________________________________

    handleStarClick(index) {
      this.modalErrors = {
        notAuthPhotosError: false,
        maxReviewPhotosError: false,
        reviewPhotoUploadError: false,
        notSelectedRaitingError: false
      };

      this.starActive.fill(false);
      this.starActive.fill(true, 0, index + 1);
      this.createdReviewData.reviewRaiting = index + 1;
    },
    handleStarHover(index) {
      this.starActive.fill(true, 0, index + 1);
    },
    handleStarUnHover() {
      if (this.createdReviewData.reviewRaiting === 0) {
        this.starActive = this.starActive.map(() => false);
      } else {
        this.starActive = this.starActive.map((_, i) => i < this.createdReviewData.reviewRaiting);
      }
    },

    setReviewTime() {
      const reviewTime = new Date();
      const timeOffset = -reviewTime.getTimezoneOffset();

      this.createdReviewData.reviewTime = ((reviewTime.getTime() + timeOffset * 60 * 1000) / 1000).toFixed();
    },

    handleReviewTagClick(tag, event) {
      tag = tag.toLowerCase().trim();

      const isChecked = event.target.checked;

      if (!isChecked) {
        const tagIndex = this.createdReviewData.tags.findIndex(revTag => revTag.text === tag.text)
        this.createdReviewData.tags.splice(tagIndex, 1);
      } else {
        this.createdReviewData.tags.push(tag);
      }
    },

    resetReviewTagsCheckboxes() {
      const checkboxArray = Array.from(document.querySelectorAll('.review-tag-checkbox'));
      checkboxArray.forEach(el => el.checked = false);
    },

    async addReviewPhotos(event) {
      this.modalErrors.notAuthPhotosError = false;
      this.modalErrors.maxReviewPhotosError = false;
      this.modalErrors.reviewPhotoUploadError = false;

      let reviewPhotos = [...event.target.files];

      // Обработка одинаковых по имени фоток при добавлении
      if (this.reviewPhotoFiles.length > 0) {
        const oldReviewPhotoNamesArray = [...this.reviewPhotoFiles].map(revPhoto => revPhoto.name);

        reviewPhotos = [...reviewPhotos].filter(revPhoto => !oldReviewPhotoNamesArray.includes(revPhoto.name));
      }
      // -----------------

      if ((this.reviewPhotoFiles.length + reviewPhotos.length) > this.maxFiles) {
        event.target.value = null;
        this.modalErrors.maxReviewPhotosError = true;

        return;
      }

      for (const revPhoto of reviewPhotos) {
        try {
          const photoStorageURL = await this.sendReviewPhoto(revPhoto);

          const reader = new FileReader();
          const promise = new Promise((resolve) => {
            reader.onload = () => {
              resolve(reader.result);
            };
            reader.readAsDataURL(revPhoto);
          });

          this.previewPhotosURLArray.push(await promise);
          this.reviewPhotoFiles.push(revPhoto);
          this.createdReviewData.photo.push(photoStorageURL);

        } catch (error) {
          this.modalErrors.reviewPhotoUploadError = true;
        }
      }
    },

    async sendReviewPhoto(file) {
      const formData = new FormData();
      formData.append('file', file);

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.addEventListener('load', () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const response = JSON.parse(xhr.responseText);
              if (response.error) {
                if (response.error === 'not auth') {
                  this.modalErrors.notAuthPhotosError = true;
                }
                if (response.error === 'too much files') {
                  this.modalErrors.maxReviewPhotosError = true;
                }
                reject(`Ошибка загрузки файла ${file.name}: ${response.error}`);
              } else {
                this.$store.commit('setFileCount', { review: Number(response.files) });
                resolve(response.url);
              }
            } catch (parseError) {
              reject(`Ошибка разбора JSON в ответе сервера: ${parseError}`);
            }
          } else {

            reject(`Ошибка загрузки файла ${file.name}: ${xhr.statusText}`);
          }
        });

        xhr.addEventListener('error', () => {
          reject(`Ошибка загрузки файла ${file.name}: Сетевая ошибка`);
        });

        xhr.addEventListener('abort', () => {
          reject(`Загрузка файла ${file.name} была прервана`);
        });

        xhr.open('POST', '/public/review/upload');

        // Добавляем заголовок initData если зашли с мобильного telegram
        if (!this.isTelegram) {
          formData.append('user', JSON.stringify(this.userInfo));
        } else {

          if (window?.Telegram?.WebApp?.initData) {
            xhr.setRequestHeader('initData', window?.Telegram?.WebApp?.initData);
            formData.append('user', {});
          }
        }

        xhr.send(formData);
      });
    },

    async removeReviewPhoto(photoIdx) {
      try {
        const headers = this.isTelegram ? {
          'Content-Type': 'application/json',
          'initData': window?.Telegram?.WebApp?.initData
        } : {
          'Content-Type': 'application/json',
        }

        const user = this.userInfo || {};
        const url = this.createdReviewData.photo[photoIdx];

        let response = await fetch('/public/review/rm_file', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ user, url })
        });
        response = await response.json();

        if (!response.found) {
          throw new Error('Файл не найден')
        }

        this.$store.commit('setFileCount', { review: response.files });
        this.previewPhotosURLArray.splice(photoIdx, 1);
        this.reviewPhotoFiles.splice(photoIdx, 1);
        this.$refs.reviewPhotosInput.value = null;
        this.createdReviewData.photo.splice(photoIdx, 1);
        this.modalErrors.maxReviewPhotosError = false;
      } catch (error) {
        console.error(`Ошибка при выполнении fetch: ${error.message}`);
      }
    },

    setReviewAuthorName() {
      try {
        const initData = localStorage.getItem("initData");
        let parsedInitData = {};

        if (initData) {
          // Разбираем строку URL-параметров
          const params = new URLSearchParams(initData);

          // Извлекаем и декодируем значение параметра "user"
          const userData = params.get('user');
          if (userData) {
            parsedInitData = JSON.parse(decodeURIComponent(userData));
          }
        }

        this.createdReviewData.name =
          this.userInfo?.first_name ||
          parsedInitData.first_name ||
          this.$static('busked.anon-customer', 'Анонiмний замовник');
      } catch (error) {
        console.error("Ошибка при обработке initData из localStorage:", error);
        this.createdReviewData.name = this.$static('busked.anon-customer', 'Анонiмний замовник');
      }
    },

    async getReviews() {
      this.isLoadingReviews = true;

      const headers = {};
      const initCache = localStorage.getItem('initData');
      if (initCache) {
        headers.initData = initCache;
      }

      let requestOptions = {
        method: 'POST',
        headers: headers
      };

      if (this.userInfo) {
        requestOptions.body = JSON.stringify({ user: this.userInfo });
      }

      let data = await fetch('/public/reviews', requestOptions);

      data = await data.json();

      this.totalReviews = data.total;
      this.loadMore = data.last;
      this.moderatedReviewsNumber = data.moderated.length;
      this.isLoadingReviews = false;
      return [...data.moderated, ...data.list] // это поле надо менять. временное решение для отобржения отзывов 
    },
    async handleReviewsListScroll() {
      const reviewsList = document.querySelector('.reviews-list');

      if (window.scrollY > reviewsList.offsetHeight - 150 && !this.isLoadingReviews) {
        await this.loadMoreReviews();
      }
    },

    async loadMoreReviews() {
      if (this.isLoadingReviews) {
        return
      }
      if (!this.loadMore) {
        return
      }
      this.isLoadingReviews = true;

      let data = await fetch('/public/reviews', { method: 'POST', body: JSON.stringify({ filter: { last: this.loadMore } }) });
      data = await data.json();

      this.totalReviews = this.totalReviews + data.total;
      this.loadMore = data.last;
      // this.moderatedReviewsNumber = data.moderated.length;
      this.isLoadingReviews = false;

      //block loading when empty list
      this.isLoadingReviews = !data.list;
      if (data.list.length) {
        this.reviews.push(...data.moderated, ...data.list);
      }
    },

    async postReview(event) {
      if (this.isReviewSending) {
        return
      }
      if (!this.createdReviewData.reviewRaiting) {
        this.modalErrors.notSelectedRaitingError = true;
        return
      }

      this.isReviewSending = true;
      let user;

      if (this.isUserLoggedIn && !this.isTelegram) {
        if (this.userInfo) {
          user = this.userInfo;
          if (user['photo_url']) {
            this.createdReviewData.reviewAuthorAvatar = user['photo_url'];
          }
        }
      }
      else if (this.isUserLoggedIn && this.isTelegram) {
        console.log("tg")
        {
          {
            const initData = localStorage.getItem("initData");
            let parsedInitData = {};

            // Разбираем строку URL-параметров
            const params = new URLSearchParams(initData);

            // Извлекаем и декодируем значение параметра "user"
            const userData = params.get('user');
            if (userData) {
              parsedInitData = JSON.parse(decodeURIComponent(userData));
              console.log(parsedInitData)
              this.createdReviewData.reviewAuthorAvatar = parsedInitData.photo_url
            }
          }
        }
      } else {
        this.createdReviewData.reviewAuthorAvatar = undefined;
        user = undefined;
      }

      this.setReviewTime();
      this.setReviewAuthorName();

      const headers = {};
      const initCache = localStorage.getItem('initData');
      if (initCache) {
        headers.initData = initCache;
      }

      const resp = await fetch('/public/review', { method: 'POST', body: JSON.stringify({ user: user, body: this.createdReviewData }), headers: headers })
      this.reviews = await this.getReviews();

      this.closeCreateReviewModal(event);
      this.openModalAfterReviewSent(resp.status);
    }
  },

  async mounted() {
    this.reviews = await this.getReviews();
    document.querySelector('title').innerHTML = 'Відгуки';

    window.addEventListener('scroll', this.handleReviewsListScroll);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleReviewsListScroll);
  }
}
</script>

<style lang="scss" scoped>
.main-reviews-container {
  width: 100%;
  max-width: 805px;
  margin: 38px auto 0;
  padding: 0 15px;

  @media (max-width: 420px) {
    width: 100vw;
    margin-top: 0;
  }

  @media (min-width: 420px) and (max-width: 767px) {
    width: 375px;
    margin-top: 0;
  }

  @media (max-width: 1199px) {
    max-width: 630px;
  }
}

.reviews-hero-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 21px;
  padding: 27px 0 41px;
  border-radius: 13px;
  background: #F8F8F8;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.10);

  @media (max-width: 767px) {
    padding: 6px 0 4px;
  }
}

.store-reviews-head {
  margin-bottom: 7px;
  color: #171717;
  font-size: 40px;
  font-weight: 500;
  line-height: 48px;

  @media (max-width: 340px) {
    font-size: 24px;
    margin-bottom: -16px;
  }

  @media (min-width: 341px) and (max-width: 767px) {
    font-size: 28px;
    margin-bottom: -16px;
  }
}

.total-mark-head {
  margin-top: 0;
  margin-bottom: 9px;
  color: #171717;
  font-size: 24px;
  font-weight: 400;
  line-height: 48px;

  @media (max-width: 767px) {
    font-size: 18px;
    margin-bottom: -8px;
  }
}

.raiting-container {
  position: relative;
  display: flex;
  column-gap: 7px;
  margin-bottom: 8px;
  overflow: hidden;

  &.in-review-block {
    column-gap: 2px;
    margin-bottom: 0;
  }

  &.in-modal {
    column-gap: 9px;
    margin-bottom: 0;

    @media (max-width: 374px) {
      column-gap: 9px;
    }
  }

  &.filled {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  @media (max-width: 767px) {
    margin-bottom: -11px;
  }
}

.raiting-star {
  flex-grow: 0;
  flex-shrink: 0;
  width: 42px;
  height: 38.25px;

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &.in-review-block {
    width: 14px;
    height: 12.75px;

    @media (max-width: 767px) {
      width: 13px;
      height: 11px;
    }
  }

  &.in-modal {
    position: relative;
    width: 44px;
    height: 36px;
    fill: none;
    cursor: pointer;
  }

  @media (max-width: 767px) {
    width: 22px;
    height: 18px;
  }
}

.reviews-count-text {
  margin-bottom: 22px;
  color: #171717;
  font-size: 24px;
  line-height: 48px;

  @media (max-width: 767px) {
    font-size: 14px;
    margin-bottom: 0;
  }
}

.write-review-btn {
  padding: 12px 27px;
  border-radius: 13px;
  background: #171717;
  color: #FFF;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;

  &:hover {
    background-color: #3b3b3b
  }

  @media (max-width: 767px) {
    display: none;
  }
}

//----------------------------------------------------------------
.reviews-header {
  margin-top: 0;
  margin-bottom: 18px;
  color: #212121;
  font-size: 18px;
  font-weight: 400;
  line-height: normal;

  @media (max-width: 767px) {
    font-size: 23px;
    font-weight: 500;
  }
}

.reviews-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.review-chain-section {
  margin-bottom: 9px;
}

.after-send-icon {
  text-align: center;
  margin-bottom: 10px;
}

.review-block {
  position: relative;
  padding: 5px 0 11px 0;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 0.10);

  &.review-block--answer {
    margin-top: 14px;
    margin-left: 77px;

    @media (max-width: 767px) {
      margin-top: 7px;
      margin-left: 37px;
    }

    & .review-block__text {
      margin-right: 27px;
    }
  }

  @media (max-width: 767px) {
    padding-top: 6px;
  }
}

.review-block__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 5px;
  border-bottom: 1px solid #D9D9D9;

  @media (max-width: 767px) {
    margin-bottom: 8px;
    padding-bottom: 6px;
  }
}

.review-block__header-part-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 0;
  flex-shrink: 0;

  @media (max-width: 767px) {
    gap: 5px;
  }

  &.left {
    margin-left: 12px;
  }

  &.right {
    gap: 3px;
    margin-right: 27px;

    @media (max-width: 767px) {
      flex-direction: column-reverse;
      margin-right: 12px;
    }
  }
}

.review-block__username-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.review-block__avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #E9E9E9;
  overflow: hidden;

  & span {
    line-height: 1;
  }

  & img {
    width: 100%;
    /* object-fit: cover; */
  }

  @media (max-width: 767px) {
    width: 32px;
    height: 32px;
  }
}


.review-block__status {
  margin-top: -2px;
  margin-bottom: 0;
  color: #747474;
  font-size: 8px;
  line-height: normal;

  &::after {
    content: url(/public/images/icons/already-buy-status-in-review.svg);
  }

  @media (max-width: 767px) {
    margin-top: 0;
  }
}


.review-block__main-content {
  padding: 0 27px;

  @media (max-width: 767px) {
    padding: 0 12px;
  }
}


.review-block__tag-container {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 108px;
  margin-bottom: 15px;


  @media (max-width: 767px) {
    margin-bottom: 12px;
  }
}


.review-block__photo-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 5px;
  margin-right: 108px;

  @media (max-width: 767px) {
    gap: 3px;
  }
}

.review-block__photo {
  width: 76px;
  height: 60px;
  border-radius: 3px;
  object-fit: cover;

  @media (max-width: 767px) {
    width: 39px;
    height: 31px;
  }
}

.review-block__answers-counter {
  position: absolute;
  bottom: 11px;
  right: 27px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  color: #353535;
  font-size: 14px;
  line-height: normal;
  text-decoration-line: underline;
  text-underline-offset: 2px;

  @media (max-width: 767px) {
    gap: 2px;
    right: 12px;
    font-size: 8px;
  }

  & svg {
    width: 10px;
    height: 10px;
  }
}

.load-more-reviews {
  width: 20px;
  margin: 18px auto 18px auto;
  background-color: transparent;
  border: none;
  color: #353535;
  font-size: 18px;
  line-height: normal;
  text-decoration-line: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  & span {
    margin-right: 8px;
  }

  & svg {
    animation: load-more 1s linear infinite;
  }

  @keyframes load-more {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}

.add-review-section-only-mobile {
  @media (min-width: 768px) {
    display: none;
  }

  position: fixed;
  bottom: 52px;
  width: 100%;
  padding: 11px 0;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.07);

  & .write-review-btn {
    margin: 0 auto;
    padding: 7px 30px;
    display: block;
  }

  & .default-btn {
    margin: 0 auto;

    display: block;
  }
}

//Modal CSS-----------------------------------------------------------------
.create-review-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 300px;
  max-width: 375px;
  height: auto;
  border-radius: 15px;
  background-color: #FFF;
  overflow: hidden;



  @media (max-width: 767px) {
    top: auto;
    bottom: 52px;
    width: 100%;

    transform: translate(-50%, 0%);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  & .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ECECEC;
    padding: 22px 15px 22px;
  }

  & .header b {
    color: #171717;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
  }
}

.close-modal-btn {
  cursor: pointer;

  &::after {
    width: 10px;
    height: 10px;
    background-color: red;
  }
}

.raiting-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 10px 33px;
}

.raiting-container-text {
  display: flex;
  column-gap: 9px;

  @media (max-width: 374px) {
    column-gap: 9px;
  }

  & div {
    position: relative;
    text-wrap: nowrap;
    width: 44px;
    height: 0;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 11px;
    line-height: normal;

    & span {
      position: absolute;
      top: 6px;
      left: 50%;
      transform: translate(-50%);
    }
  }
}

.section-line-devider {
  height: 1px;
  margin: 0 15px 0;
  background-color: rgba(0, 0, 0, 0.10);
}

.review-text-section {
  padding: 11px 15px 14px;
}

.modal-review-textarea {
  display: block;
  width: 100%;
  min-height: 115px;
  margin-bottom: 17px;
  padding: 12px 15px;
  border-radius: 7px;
  border: 1px solid #F5F5F5;
  background-color: #F5F5F5;
  font-size: 12px;

  &:hover {
    border: 1px solid #cdcdcd;
  }

  &::placeholder {
    color: #797979;
    font-size: 12px;
    line-height: 9px;
  }

  &:focus::placeholder {
    opacity: 0;
  }
}

.leave-comment-сall-to-action {
  margin-bottom: 14px;
  color: #797979;
  font-size: 12px;
  font-weight: 400;
  line-height: 9px;
}

.review-block__tag-container--in-modal {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;
  column-gap: 10px;
  row-gap: 7px;
}

.review-tag-checkbox {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  white-space: nowrap;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;

  &:checked+.review-block__tag--in-modal {
    color: #fff;
    background-color: #171717;
    border-color: #171717;
  }
}

.review-block__tag--in-modal {
  padding: 4px 10px;
  margin-bottom: 0;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  background-color: #f3f3f3;

  &:hover {

    border-color: #868686;
  }

  &::before {
    display: none;
  }
}

.photo-section {
  padding: 13px 0 9px 0;
}

.modal-review__photo-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 9px;
  padding: 0 16.5px;
}

.modal-review__photo-wrapper {
  position: relative;
}

.modal-review__photo {
  width: 75px;
  height: 60px;
  border-radius: 3px;
  object-fit: cover;

}

.modal-review__photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 3px;
  background-color: rgba(222, 222, 222, 0.70);
  ;
}

.modal-review__photo-delete-btn {
  position: absolute;
  right: 50%;
  top: 50%;
  transform: translate(50%, -50%);
  z-index: 2;
  cursor: pointer;
}

.modal-review__photo-upload-btn-immitator {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0 15px;
  padding-top: 23px;
  padding-bottom: 23px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 7px;
  border: 1px dashed #CDCDCD;
  background: #F5F5F5;
  color: #797979;
  font-size: 14px;
  line-height: 1.1;
  cursor: pointer;

  &:hover {
    border: 1px dashed #cdcdcd;
    opacity: 0.75;
  }

  & input[type="file"] {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;

    white-space: nowrap;
    clip-path: inset(100%);
    clip: rect(0 0 0 0);
    overflow: hidden;
  }
}

.modal-review__photo-upload-content-wrapper {
  display: flex;
  align-items: center;
  gap: 9px;
}

.modal-review__upload-photo-icon {
  width: 14px;
  height: 14px;
}

.send-btn-section {
  display: flex;
  justify-content: center;
  padding: 19px 0;

  @media (max-width: 767px) {
    padding: 12px 0;
  }
}

.help-text {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translate(-50%, 0);
  color: red;
  background-color: #fff;
  margin-top: 10px;
  font-size: 11px;
  line-height: 1.2;
}

.help-text__in-raiting {
  top: 0;
  bottom: auto;
}

//--------after review sent modal

.review-after-send-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 281px;
  padding: 35px 49px;
  border-radius: 15px;
  background-color: #FFF;
  overflow: hidden;

  @media (min-width: 768px) {
    width: 351px;
    padding: 48px 51px;
  }
}

.close-modal-btn__review-after-send-modal {
  position: absolute;
  top: 12px;
  right: 12px;

  @media (min-width: 768px) {
    top: 14px;
    right: 14px;
  }
}

.review-after-send-modal__content-wrapper {


  & b {
    display: block;
    margin-bottom: 8px;
    color: #353535;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;

    &.send-modal-error {
      color: red;
    }

    @media (min-width: 768px) {
      font-size: 24px;
    }
  }

  & p {
    color: #171717;
    font-size: 12px;
    line-height: normal;
    text-align: center;

    @media (min-width: 768px) {
      font-size: 19px;
    }
  }
}

.uplod-input-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.small_mb {
  margin-bottom: 4px;
}
</style>